import { useState, useEffect } from "react";

const navLinks = [
  { label: "Inicio", href: "#inicio" },
  { label: "Servicios", href: "#servicios" },
  { label: "Sobre nosotros", href: "#sobre-nosotros" },
  { label: "Preguntas frecuentes", href: "#faq" },
  { label: "Contacto", href: "#contacto" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm border-b border-faro-gray-mid" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <a href="#inicio" onClick={() => handleNavClick("#inicio")} className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/73dfd2d3-6ecc-4d20-afd5-49901dbfd111.png"
            alt="Faro Energía"
            className={`h-16 w-auto object-contain transition-all duration-300 ${
              scrolled ? "" : "brightness-0 invert"
            }`}
          />
        </a>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-faro-navy hover:text-faro-teal"
                  : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        {/* CTA Button */}
        <div className="hidden lg:block">
          <button
            onClick={() => handleNavClick("#contacto")}
            className="bg-faro-yellow hover:bg-faro-yellow-light text-faro-navy text-sm font-semibold px-5 py-2.5 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Estudio gratuito
          </button>
        </div>

        {/* Mobile menu button */}
        <button
          className={`lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? "text-faro-navy" : "text-white"}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Abrir menú"
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-2xl`} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-faro-gray-mid px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="text-faro-navy text-base font-medium text-left cursor-pointer whitespace-nowrap hover:text-faro-teal transition-colors"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => handleNavClick("#contacto")}
            className="bg-faro-yellow hover:bg-faro-yellow-light text-faro-navy text-sm font-semibold px-5 py-2.5 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap w-full mt-2"
          >
            Estudio gratuito
          </button>
        </div>
      )}
    </header>
  );
}
